import React from 'react';
import { ChevronDownIcon, MapPinIcon } from 'lucide-react';
import { IMAGES, LINKS } from '../data/site';
import { additionalServiceAreas, hours, locations, primaryServiceArea } from '../data/locations';
const serviceLinks = [{
  label: 'Auto Glass',
  href: LINKS.auto
}, {
  label: 'Windshield Chip Repair',
  href: LINKS.chip
}, {
  label: 'ADAS Calibration',
  href: LINKS.adas
}, {
  label: 'Residential Glass',
  href: LINKS.residential
}, {
  label: 'Glass Shower Doors',
  href: LINKS.shower
}, {
  label: 'Commercial Glass',
  href: LINKS.commercial
}];
const supportLinks = [{
  label: 'Glass Resources & Guides',
  href: LINKS.resources
}, {
  label: 'Emergency Auto Glass',
  href: LINKS.emergencyAuto
}, {
  label: 'Contact Kosin’s Glass',
  href: LINKS.contact
}, {
  label: 'Locations & hours',
  href: '#locations'
}];
export function Footer() {
  const mainOffice = locations.find(office => office.isPrimary)!;
  const satelliteOffices = locations.filter(office => !office.isPrimary);
  return <footer className="w-full bg-kosin-charcoal" data-id="element-59" data-mp="3l8qupznvcbpc">
      <div className="mx-auto max-w-shell px-[18px] pb-6 pt-10 sm:px-6 lg:pt-12" data-id="element-60" data-mp="3lbmttrbgd6fd">
        <div className="grid grid-cols-1 gap-x-10 gap-y-10 sm:grid-cols-2 lg:grid-cols-[1.05fr_0.85fr_2.1fr]" data-id="element-61" data-mp="3gc0glhvmjq6k">
          <div className="min-w-0" data-id="element-62" data-mp="3v916rgy63d2x">
            <div className="inline-block rounded bg-white px-3 py-2" data-id="element-63" data-mp="3q8wpvptckgc6">
              <img src={IMAGES.logo} alt="Kosin’s Glass" width={227} height={95} className="h-[54px] w-auto" data-id="element-64" data-mp="3qapwx67vh2kp" />
            </div>
            <p className="mt-4 max-w-[300px] text-[15px] leading-relaxed text-white/70" data-id="element-65" data-mp="3477xwrgsq3h">
              Family-owned glass company serving Southeast Michigan since 2000.
            </p>
            <section aria-labelledby="footer-service-area-heading" className="mt-7" data-id="element-66" data-mp="ctqmwrc23zt2">
              <h2 id="footer-service-area-heading" className="text-[15px] font-semibold text-white" data-id="element-67" data-mp="cw33b0262240">Service Area</h2>
              <p className="mt-2 text-[14px] leading-relaxed text-white/70" data-id="element-68" data-mp="mrwmh2ae4tur">{primaryServiceArea}</p>
              <details className="group mt-1" data-id="element-69" data-mp="tvczjrxji5f5">
                <summary className="focus-light flex min-h-11 cursor-pointer list-none items-center justify-between gap-3 text-[14px] font-medium text-white hover:text-kosin-ondark [&::-webkit-details-marker]:hidden" data-id="element-70" data-mp="twfs04aigfx6">
                  More Service Areas
                  <ChevronDownIcon className="h-4 w-4 shrink-0 text-kosin-ondark transition-transform group-open:rotate-180" aria-hidden="true" data-id="element-71" data-mp="18jr201r1nrv6" />
                </summary>
                <p className="mt-1 text-[14px] leading-relaxed text-white/70" data-id="element-72" data-mp="1cnp2ogw0paqc">{additionalServiceAreas.join(' · ')}</p>
              </details>
            </section>
          </div>

          <div className="grid min-w-0 grid-cols-2 content-start gap-x-5 gap-y-7 lg:grid-cols-1" data-id="element-73" data-mp="1mkbiusdefdm1">
            {[{
            title: 'Services',
            label: 'Services',
            links: serviceLinks
          }, {
            title: 'Resources & Contact',
            label: 'Resources and contact',
            links: supportLinks
          }].map(group => <nav key={group.title} aria-label={group.label} data-id="element-74" data-mp="3tc2w70kvqxgn">
                <h2 className="text-[15px] font-semibold text-white" data-id="element-75" data-mp="2afwz4q22lr18">{group.title}</h2>
                <ul className="mt-2 text-[14px] leading-5" data-id="element-76" data-mp="25nc8tyidhw2g">
                  {group.links.map(link => <li key={link.label} data-id="element-77" data-mp="21nle5jpq6vsn">
                      <a href={link.href} className="focus-light inline-flex min-h-11 items-center py-1.5 text-white/70 transition-colors duration-150 ease-kosin hover:text-white lg:min-h-8" data-id="element-78" data-mp="1wnp8lg1dqwaz">{link.label}</a>
                    </li>)}
                </ul>
              </nav>)}
          </div>

          <section id="locations" tabIndex={-1} aria-label="Locations and business hours" className="grid min-w-0 grid-cols-1 content-start gap-x-8 gap-y-9 sm:col-span-2 sm:grid-cols-[1.1fr_1fr] lg:col-span-1" data-id="element-79" data-mp="2kcrytca2xxh3">
            <div className="min-w-0" data-id="element-80" data-mp="18yeeghejc05t">
              <section aria-labelledby="footer-howell-heading" data-id="element-81" data-mp="18zftewyo96st">
                <h2 id="footer-howell-heading" className="text-[18px] font-semibold text-white" data-id="element-82" data-mp="13y060y90uo79">{mainOffice.city}</h2>
                <p className="mt-1 text-[13px] font-semibold leading-5 text-kosin-ondark" data-id="element-83" data-mp="2ru6d7qgvz7i0">{mainOffice.role}</p>
                <address className="mt-3 text-[14px] not-italic leading-relaxed text-white/70" data-id="element-84" data-mp="2wnr1gqsogn40">
                  {mainOffice.address.map(line => <span key={line} className="block" data-id="element-85" data-mp="2nu5p1e3zjhxr">{line}</span>)}
                </address>
                <a href={mainOffice.phoneHref} className="focus-light mt-1 inline-flex min-h-11 items-center text-[17px] font-semibold text-white transition-colors hover:text-kosin-ondark" data-id="element-86" data-mp="2nrrxhf8iknuy">{mainOffice.phoneDisplay}</a>
                {mainOffice.directionsUrl && <a href={mainOffice.directionsUrl} className="focus-light flex min-h-11 items-center gap-1.5 text-[14px] text-white/70 underline underline-offset-4 hover:text-white" data-id="element-87" data-mp="31l0xwqehhz1c">
                    <MapPinIcon className="h-4 w-4 shrink-0 text-kosin-ondark" aria-hidden="true" data-id="element-88" data-mp="1q5m4txpebrbi" />
                    Get Directions To Howell
                  </a>}
              </section>
              <section aria-labelledby="footer-hours-heading" className="mt-7" data-id="element-89" data-mp="1nkecykyo3jvt">
                <h2 id="footer-hours-heading" className="text-[15px] font-semibold text-white" data-id="element-90" data-mp="1iltcckfi6y6u">Business Hours</h2>
                <dl className="mt-2 max-w-[380px] text-[13px] leading-5" data-id="element-91" data-mp="1wlcm1hnyqhl9">
                  {hours.map(row => <div key={row.day} className="flex flex-wrap justify-between gap-x-3 gap-y-1 py-1.5" data-id="element-92" data-mp="1rocawsc9aona">
                      <dt className="text-white/70" data-id="element-93" data-mp="13vvusnc2x6qm">{row.day}</dt>
                      <dd className="m-0 whitespace-nowrap font-medium text-white" data-id="element-94" data-mp="zxod9q9sk1ed">{row.time}</dd>
                    </div>)}
                </dl>
              </section>
            </div>
            <section aria-labelledby="footer-satellite-heading" className="min-w-0" data-id="element-95" data-mp="18w9thersj4bz">
              <h2 id="footer-satellite-heading" className="text-[15px] font-semibold text-white" data-id="element-96" data-mp="l6ffuuzndbqo">Satellite Offices</h2>
              <ul className="mt-4 space-y-7" data-id="element-97" data-mp="g7urptxo6iil">
                {satelliteOffices.map(office => <li key={office.city} className="min-w-0" data-id="element-98" data-mp="2ga41phklul1j">
                    <h3 className="text-[16px] font-semibold text-white" data-id="element-99" data-mp="2l96tw1fhkws3">{office.city}</h3>
                    <address className="mt-2 text-[14px] not-italic leading-relaxed text-white/70" data-id="element-100" data-mp="2q0ougodlkvcj">
                      {office.address.map(line => <span key={line} className="block" data-id="element-101" data-mp="2uy8anttuvi74">{line}</span>)}
                    </address>
                    <a href={office.phoneHref} className="focus-light mt-1 inline-flex min-h-11 items-center text-[15px] font-semibold text-white transition-colors hover:text-kosin-ondark" data-id="element-102" data-mp="1xd2udq3kw8uf">{office.phoneDisplay}</a>
                  </li>)}
              </ul>
            </section>
          </section>
        </div>
        <p className="mt-9 border-t border-white/10 pt-5 text-[13px] text-white/60" data-id="element-103" data-mp="2bcvev3oihsty">
          © {new Date().getFullYear()} Kosin’s Glass. All rights reserved.
        </p>
      </div>
    </footer>;
}